import * as React from 'react'

import { ReactComponent as Facebook } from './facebook.svg'
import { ReactComponent as Instagram } from './instagram.svg'
import { ReactComponent as Linkedin } from './linkedin.svg'
import { ReactComponent as Twitter } from './twitter.svg'

import styles from './social-media.module.scss'

interface ISocialMediaProps {
  variant?: 'default' | 'brand' | 'free'
  size?: 'regular' | 'large'
  style?: React.CSSProperties
}

const getProps = ({ variant, isLast, style, size }: ISocialMediaProps & { isLast?: boolean }) => ({
  className: [
    styles.icon,
    variant === 'brand' && styles.brand,
    variant === 'free' && styles.free,
    size === 'large' && styles.large,
    isLast && styles.last,
  ]
    .filter(Boolean)
    .join(' '),
  style,
})

const SocialMedia = ({ variant = 'default', style = {}, size = 'regular' }: ISocialMediaProps) => {
  const props = getProps({ variant, style, size })

  const linkProps = {
    target: '_blank',
    rel: 'noopener noreferrer',
  }

  return (
    <div className={styles.wrapper}>
      <a href="https://www.facebook.com/dooerhq" {...linkProps}>
        <Facebook {...props} />
      </a>
      <a href="https://www.instagram.com/dooerhq/" {...linkProps}>
        <Instagram {...props} />
      </a>
      <a href="https://www.linkedin.com/company/dooer" {...linkProps}>
        <Linkedin {...props} />
      </a>
      <a href="https://twitter.com/dooerhq" {...linkProps}>
        <Twitter {...getProps({ variant, style, size, isLast: true })} />
      </a>
    </div>
  )
}

export default SocialMedia
